import React, { useEffect, useState } from 'react';
import Moment from "moment";
import 'chartjs-plugin-datalabels';
import { Card, CardBody, CardTitle, Col,  Row } from "reactstrap";

import XwitchDashboardFilters from "./_filters";
import { showLoader } from "../../../components/loader/loader";
import { showToastCustom } from "../../../components/toast/customToast";
import { xwitchLogService } from "../../../jwt/_services/bi/xwitchLogService";
import { error } from "../../../components/i18n/i18n";
import { CardChartBar } from "../../../components/charts/ChartBar";
import { CardChartPie } from "../../../components/charts/ChartPie";
import { getFirstDayOfMonth, getLastDayOfMonth} from "../../../util/DateTools";
import {
    totalTransactHeaders,
    transactByHourHeader, transactByServiceHeader,
    transactByWeekHeaders, transactStatusHeaders
} from "../../../util/CartTools";

export default function XwitchDashboard() {
    const [loading, setLoading] = useState(false);
    const [collapsed, setCollapsed] = useState(true);
    const today = new Date()

    const [dataFilter, setDataFilter] = useState({
        separateWorldpay : false,
        to : Moment( getLastDayOfMonth(today.getFullYear(), today.getMonth()) ).format('YYYY-MM-DD'),
        from : Moment( getFirstDayOfMonth(today.getFullYear(), today.getMonth()) ).format('YYYY-MM-DD')
    });

    const [acceptReject, setAcceptReject] = useState(null);
    const [acceptRejectRawData, setAcceptRejectRawData] = useState(null);

    const [byDOW, setByDOW] = useState(null);
    const [byDOWRawData, setByDOWRawData] = useState(null);

    const [byHour, setByHour] = useState(null);
    const [byHourRawData, setByHourRawData] = useState(null);

    const [byService, setByService] = useState(null);
    const [byServiceRawData, setByServiceRawData] = useState(null);

    const [saleTotal, setSaleTotal] = useState(null)
    const [saleTotalRawData, setSaleTotalRawData] = useState(null)


    useEffect(() => {
        refreshDashboard(dataFilter);
    }, []);

    const showFilters = () => setCollapsed(!collapsed);

    const refreshFiltered = (_dataFilter) => {
        setDataFilter(_dataFilter);
        refreshDashboard(_dataFilter);
    }

    const refreshDashboard = ( _dataFilter ) => {
        setLoading(true);
        xwitchLogService.searchDashboard( _dataFilter)
            .then(result => {
                console.log(result)
                if (result){
                    if (result.acceptReject?.list !== null)
                        setAcceptReject(mapSaleVsNoSale(result.acceptReject?.list, _dataFilter));

                    if (result.acceptReject?.totales !== null)
                        setSaleTotal(mapBySaleTotales(result.acceptReject?.totales, _dataFilter));

                    if (result.byDOW !== null)
                        setByDOW(mapByDow(result.byDOW));

                    if (result.byHour !== null)
                        setByHour(mapByHour(result.byHour));

                    if (result.byApp !== null)
                        setByService(mapByService(result.byApp));
                } else {
                    setAcceptReject(null);
                    setByDOW(null);
                    setByHour(null);
                }
                setLoading(false);
            })
            .catch(errorMessage => {
                setAcceptReject(null);
                setByDOW(null);
                setByHour(null);
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
    }

    const mapSaleVsNoSale = (_saleVsNoSale, _dataFilter) => {
        setAcceptRejectRawData(_saleVsNoSale)

        const _dates = _saleVsNoSale.map((item) => {
            return item.date;
        });

        const _ok = _saleVsNoSale.map((item) => item.ok);

        const _okWP = _saleVsNoSale.map((item) => {
            if (item.okWP > 0 )
                return item.okWP

            return
        });

        const _bankReject = _saleVsNoSale.map((item) => {
            if (item.bankReject > 0 )
                return item.bankReject

            return
        } );
        const _bankRejectWP = _saleVsNoSale.map((item) => {
            if (item.bankRejectWP > 0 )
                return item.bankRejectWP

            return
        } );

        const _fraudReject = _saleVsNoSale.map((item) => {
            if(item.fraudReject > 0)
                return item.fraudReject;

            return
        });
        const _fraudRejectWP = _saleVsNoSale.map((item) => {
            if(item.fraudRejectWP > 0)
                return item.fraudRejectWP;

            return
        });

        const _error = _saleVsNoSale.map((item) => {
            if(item.error > 0)
                return item.error;

            return
        });
        const _errorWP = _saleVsNoSale.map((item) => {
            if(item.errorWP > 0)
                return item.errorWP;

            return
        });

        if (_dataFilter.separateWorldpay) {
            return {
                labels: _dates,
                datasets: [
                    {
                        label: 'Ok',
                        data: _ok,
                        borderColor: 'rgb(96,140,48)',
                        backgroundColor: 'rgba(96,140,48, .60)',
                        borderWidth: 1,
                    },
                    {
                        label: 'OkWP',
                        data: _okWP,
                        borderColor: 'rgb(141,183,95)',
                        backgroundColor: 'rgba(141,183,95, .60)',
                        borderWidth: 1,
                    },
                    {
                        label: 'Banco',
                        data: _bankReject,
                        borderColor: 'rgb(239, 152, 67)',
                        backgroundColor: 'rgba(239, 152, 67, .60)',
                        borderWidth: 1,
                    },
                    {
                        label: 'BancoWP',
                        data: _bankRejectWP,
                        borderColor: 'rgb(239, 164, 90)',
                        backgroundColor: 'rgba(239, 164, 90, .60)',
                        borderWidth: 1,
                    },
                    {
                        label: 'Fraude',
                        data: _fraudReject,
                        borderColor: 'rgb(234, 97, 53)',
                        backgroundColor: 'rgba(234, 97, 53, .60)',
                        borderWidth: 1,
                    },
                    {
                        label: 'FraudeWP',
                        data: _fraudRejectWP,
                        borderColor: 'rgb(245, 130, 94)',
                        backgroundColor: 'rgba(245, 130, 94, .60)',
                        borderWidth: 1,
                    },
                    {
                        label: 'Error',
                        data: _error,
                        borderColor: 'rgb(135, 34, 23)',
                        backgroundColor: 'rgba(135, 34, 23, .60)',
                        borderWidth: 1,
                    },
                    {
                        label: 'ErrorWP',
                        data: _errorWP,
                        borderColor: 'rgb(157, 49, 38)',
                        backgroundColor: 'rgba(157, 49, 38, .60)',
                        borderWidth: 1,
                    },
                ],

            };
        } else {
            let output = {
                labels: _dates,
                datasets: [
                    {
                        label: 'Ok',
                        data: _ok,
                        borderColor: 'rgb(96,140,48)',
                        backgroundColor: 'rgba(96,140,48, .60)',
                        borderWidth: 1,
                    },
                    {
                        label: 'Banco',
                        data: _bankReject,
                        borderColor: 'rgb(239, 152, 67)',
                        backgroundColor: 'rgba(239, 152, 67, .60)',
                        borderWidth: 1,
                    },
                    {
                        label: 'Fraude',
                        data: _fraudReject,
                        borderColor: 'rgb(234, 97, 53)',
                        backgroundColor: 'rgba(234, 97, 53, .60)',
                        borderWidth: 1,
                    },
                    {
                        label: 'Error',
                        data: _error,
                        borderColor: 'rgb(135, 34, 23)',
                        backgroundColor: 'rgba(135, 34, 23, .60)',
                        borderWidth: 1,
                    },
                ],

            };

            return output
        }
    }

    const mapByDow = (_byDow) => {
        const _labels = [ 'L', 'M', 'Mi', 'J', 'V', 'S', 'D' ];

        let rawData = {}

        _labels.forEach( (value,position)=> {
            const dow = _byDow.find(item => item.dow === (position + 1));
            rawData = {...rawData, [value]: (dow !== undefined ? dow?.cant : 0)}
        } )

        setByDOWRawData([ rawData ])

        const _values = [1,2,3,4,5,6,7].map((ndow) => {
            const dow = _byDow.find(item => item.dow === ndow.toString());
            if(dow !== undefined && dow != null)
                return dow.cant

            return
        });

        return {
            labels: _labels,
            datasets: [
                {
                    label: '',
                    data: _values,
                    borderColor: 'rgb(13,0,132)',
                    backgroundColor: 'rgba(0,80,145,0.60)',
                    borderWidth: 1,
                }
            ],
        };
    }

    const mapByHour = (_byHour) => {
        const _labels = [
              '00','01', '02', '03', '04', '05', '06', '07', '08', '09'
            , '10','11', '12', '13', '14', '15', '16', '17', '18', '19'
            , '20','21', '22', '23'
        ];

        let rawData = {}

        _labels.forEach( (value)=> {
            const hour = _byHour.find(item => item.hour === value);
            rawData = {...rawData, [value]: (hour !== undefined ? hour?.cant : 0)}
        } )

        setByHourRawData([ rawData ])

        const _values = _labels.map((h) => {
            const hod = _byHour.find(item => item.hour === h);
            if(hod !== undefined && hod != null)
                return hod?.cant
        });

        return {
            labels: _labels,
            datasets: [
                {
                    label: '',
                    data: _values,
                    borderColor: 'rgb(13,0,132)',
                    backgroundColor: 'rgba(0,80,145,0.75)',
                    borderWidth: 1,
                }
            ],
        };
    }

    const mapByService = (_byService) => {
        const _labels = [ 'PARK','HOTEL','FERRY','HCDP' ];

        const _values = _labels.map((serv) => {
            const bs = _byService.find(item => item.app === serv);
            return (bs !== undefined && bs != null) ? bs.cant : 0 ;
        });

        let output = {}
        _labels.forEach( item => {
            const element = _byService.find( it => it.app === item )
            output = { ...output, [item]: element?.cant || 0}
        })
        setByServiceRawData([output])

        return {
            labels: _labels,
            datasets: [
                {
                    label: '',
                    data: _values,
                    borderColor: [
                        'rgba(75, 192, 192, 1)',
                        'rgba(54, 162, 235, 1)',
                        'rgba(96, 140, 48, 1)',
                        'rgba(234, 97, 53, 1)',
                    ],
                    backgroundColor: [
                        'rgba(75, 192, 192, 0.2)',
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(96, 140, 48, 0.2)',
                        'rgba(234, 97, 53, 0.2)',
                    ],
                    borderWidth: 1,
                }
            ],
        };
    }

    const mapBySaleTotales = (_totales, _dataFilter) => {
        setSaleTotalRawData([ _totales ])
        const _labels = Object.keys(_totales)

        const _values = []

         _labels.forEach( (serv) => {
            _values.push( _totales[serv] );
        });

        if (_dataFilter.separateWorldpay) {
            return {
                labels: _labels,
                datasets: [
                    {
                        label: '',
                        data: _values,
                        borderColor: [
                            'rgba(96,140,48, 1)',
                            'rgb(141,183,95)',
                            'rgba(239, 152, 67, 1)',
                            'rgb(239,164,90)',
                            'rgba(234, 97, 53, 1)',
                            'rgb(245,130,94)',
                            'rgba(135, 34, 23, 1)',
                            'rgb(157,49,38)',
                        ],
                        backgroundColor: [
                            'rgba( 96, 140, 48, 0.60)',
                            'rgba(141, 183, 95, 0.60)',
                            'rgba(239, 152, 67, 0.60)',
                            'rgba(239, 164, 90, 0.60)',
                            'rgba(234,  97, 53, 0.60)',
                            'rgba(245, 130, 94, 0.60)',
                            'rgba(135,  34, 23, 0.60)',
                            'rgba(157,  49, 38, 0.60)',
                        ],
                        borderWidth: 1,
                    }
                ],
            };
        } else {
            return {
                labels: _labels,
                datasets: [
                    {
                        label: '',
                        data: _values,
                        borderColor: [
                            'rgba(96,140,48, 1)',
                            'rgba(239, 152, 67, 1)',
                            'rgba(234, 97, 53, 1)',
                            'rgba(135, 34, 23, 1)',
                        ],
                        backgroundColor: [
                            'rgba( 96, 140, 48, 0.60)',
                            'rgba(239, 152, 67, 0.60)',
                            'rgba(234,  97, 53, 0.60)',
                            'rgba(135,  34, 23, 0.60)',
                        ],
                        borderWidth: 1,
                    }
                ],
            };
        }
    }



    return (
        <div>
            {loading && showLoader()}
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>
                </CardTitle>
                <XwitchDashboardFilters refreshFiltered={refreshFiltered} />
                <CardBody>
                    <Row>
                        <Col className='col-md-12'>
                            {
                                acceptReject != null && <CardChartBar
                                    title = 'Transacciones por dia'
                                    rawData = { acceptRejectRawData }
                                    headers = { transactStatusHeaders }
                                    graphicData = { acceptReject }
                                />
                            }
                        </Col>
                    </Row>
                    <br/><br/><br/>
                    <Row>
                        <Col>
                            {

                                byDOW != null && <CardChartBar
                                    title='Transacciones por dia de la semana'
                                    rawData = { byDOWRawData }
                                    headers = { transactByWeekHeaders }
                                    graphicData={ byDOW }
                                />
                            }
                        </Col>
                        <Col>
                            {
                                byHour != null && <CardChartBar
                                    title='Transacciones por hora'
                                    rawData = { byHourRawData }
                                    headers = { transactByHourHeader }
                                    graphicData={ byHour }
                                />
                            }
                        </Col>
                    </Row>
                    <br/><br/><br/>
                    <Row>
                        <Col>
                            {
                                saleTotal != null && <CardChartPie
                                    title = 'Transacciones por dia'
                                    rawData = { saleTotalRawData }
                                    headers = { totalTransactHeaders }
                                    graphicData = { saleTotal }
                                />
                            }
                        </Col>
                        <Col>
                            {
                                byService != null && <CardChartPie
                                    title='Transacciones por servicio'
                                    rawData = { byServiceRawData }
                                    headers = { transactByServiceHeader }
                                    graphicData={ byService }
                                />
                            }
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </div>
    );
}